import React from 'react';

import PropTypes from 'prop-types';

import { Flex } from 'antd';
import ClientPortfolioListItem from './ClientPortfolioListItem';
import SkeletonClientInfo from '../../Clients/Skeleton/SkeletonClientInfo';
import ClientPortfolioCompositetem from './ClientPortfolioCompositetem';

const ClientPortfolioList = ({
  portfolios,
  selectedRowKeys,
  setSelectedRowKeys,
  isLoading,
  theme,
  userId,
}) => {
  if (isLoading) {
    return <SkeletonClientInfo />;
  }

  const sortedPortfolios = portfolios?.slice()?.filter((item) => !item.is_composite)?.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
  const compositePortfolios = portfolios?.slice()?.find((item) => item.is_composite);
  return (
    <Flex
      className="client portfolio-list-wrapper"
      onWheel={(e) => {
        const container = e.currentTarget;
        if (e.deltaY !== 0) {
          e.preventDefault();
          container.scrollLeft += e.deltaY;
        }
      }}
    >
      <ClientPortfolioCompositetem 
        item={compositePortfolios ?? null} 
        selectedRowKeys={selectedRowKeys} 
        setSelectedRowKeys={setSelectedRowKeys} 
        theme={theme} 
        userId={userId}
        />
      {sortedPortfolios?.map((item) => {
        return (
          <ClientPortfolioListItem
            key={item.id}
            item={item}
            deprecated={item.status === 'ACTIVE_DEPRECATED'}
            is_locked={item.is_locked}
            selectedRowKeys={selectedRowKeys}
            setSelectedRowKeys={setSelectedRowKeys}
            theme={theme}
          />
        );
      })}
    </Flex>
  );
};

export default ClientPortfolioList;

ClientPortfolioList.propTypes = {
  portfolios: PropTypes.array,
  handleEdit: PropTypes.func,
  selectedRowKeys: PropTypes.number,
  setSelectedRowKeys: PropTypes.func,
  isLoading: PropTypes.bool,
  theme: PropTypes.string,
  userId: PropTypes.string,
};
